module.exports = __webpack_public_path__ + "static/drive4-min-df89d0baed67d82aec55312c3b03d440.png";